import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-384bdf60"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "user-exam-header-container"
};
var _hoisted_2 = {
  class: "header-tip-container-box"
};
var _hoisted_3 = ["title"];
var _hoisted_4 = {
  key: 0,
  class: "paper-info-box"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "paper-info-title"
  }, "答卷ID：", -1);
});
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "paper-info-title"
  }, "试卷总分：", -1);
});
var _hoisted_9 = {
  key: 2
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "paper-info-title"
  }, "共耗时：", -1);
});
var _hoisted_11 = {
  key: 3
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "paper-info-title"
  }, "答题时间：", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "返回试卷", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", {
    class: "reload-tips"
  }, " 项目加载或者表现异常时可尝试点击此处重新加载。 ", -1);
});
var _hoisted_15 = /*#__PURE__*/_createTextVNode(" 重载项目 ");
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "作品介绍", -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "交卷", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HeaderTip = _resolveComponent("HeaderTip");
  var _component_LeftOutlined = _resolveComponent("LeftOutlined");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_popconfirm = _resolveComponent("a-popconfirm");
  var _component_Countdown = _resolveComponent("Countdown");
  var _component_FileTextOutlined = _resolveComponent("FileTextOutlined");
  var _component_SendOutlined = _resolveComponent("SendOutlined");
  var _component_a_row = _resolveComponent("a-row");
  var _component_WorkProfileDialog = _resolveComponent("WorkProfileDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_HeaderTip, {
    tip: _ctx.tip
  }, null, 8, ["tip"])]), _createVNode(_component_a_row, {
    type: "flex"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "auto"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", {
            class: _normalizeClass([_ctx.examService.answerPaperInfo ? 'exam-full-width' : 'exam-name-text'])
          }, [_createElementVNode("span", {
            title: _ctx.examService.exam.examName
          }, _toDisplayString(_ctx.examService.exam.examName), 9, _hoisted_3), _ctx.examService.answerPaperInfo ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_ctx.examService.answerPaperInfo.answerPaperId ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(_ctx.examService.answerPaperInfo.answerPaperId), 1)])) : _createCommentVNode("", true), _ctx.examService.answerPaperInfo.userTotalScore >= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.examService.answerPaperInfo.userTotalScore) + "分", 1)])) : _createCommentVNode("", true), _ctx.examService.answerPaperInfo.costTime >= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.examService.answerPaperInfo.costTime / 60)) + "分钟", 1)])) : _createCommentVNode("", true), _ctx.examService.answerPaperInfo.beginAnswerTime ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_ctx.formatDateToSecond(_ctx.examService.answerPaperInfo.beginAnswerTime)) + "-" + _toDisplayString(_ctx.formatDateToSecond(_ctx.examService.answerPaperInfo.commitAnswerTime)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2), [[_vShow, !_ctx.questionService.showIde]]), _withDirectives(_createVNode(_component_a_button, {
            class: "btn-blue",
            type: "default",
            shape: "round",
            size: "large",
            onClick: _ctx.onHideIde
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_LeftOutlined)];
            }),
            default: _withCtx(function () {
              return [_hoisted_13];
            }),
            _: 1
          }, 8, ["onClick"]), [[_vShow, _ctx.questionService.showIde]])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        flex: "450px"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_row, {
            justify: "end"
          }, {
            default: _withCtx(function () {
              return [_ctx.questionService.showIde ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_popconfirm, {
                    placement: "bottom",
                    "ok-text": "确认",
                    "cancel-text": "取消",
                    overlayClassName: "ide-reload-popconfirm",
                    onConfirm: _ctx.reloadIframe
                  }, {
                    title: _withCtx(function () {
                      return [_hoisted_14];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(_component_a_button, {
                        class: "reload-iframe",
                        onClick: _ctx.reloadIframeClick
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_15];
                        }),
                        _: 1
                      }, 8, ["onClick"])];
                    }),
                    _: 1
                  }, 8, ["onConfirm"])];
                }),
                _: 1
              })) : _createCommentVNode("", true), !_ctx.examService.answerMode ? (_openBlock(), _createBlock(_component_a_col, {
                key: 1
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_Countdown, {
                    title: "剩余时间：",
                    time: _ctx.countdownService.remainTime
                  }, null, 8, ["time"])];
                }),
                _: 1
              })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_a_col, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_button, {
                    class: "btn-orange ml15",
                    type: "default",
                    shape: "round",
                    size: "large",
                    onClick: _ctx.questionService.showWorkProfileDialog
                  }, {
                    icon: _withCtx(function () {
                      return [_createVNode(_component_FileTextOutlined)];
                    }),
                    default: _withCtx(function () {
                      return [_hoisted_16];
                    }),
                    _: 1
                  }, 8, ["onClick"])];
                }),
                _: 1
              }, 512), [[_vShow, _ctx.questionService.showIde && _ctx.questionService.isProgramCreation]]), _withDirectives(_createVNode(_component_a_col, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_button, {
                    class: "btn-orange ml15",
                    type: "default",
                    shape: "round",
                    size: "large",
                    onClick: _ctx.onManualSubmitExam
                  }, {
                    icon: _withCtx(function () {
                      return [_createVNode(_component_SendOutlined, {
                        rotate: -45,
                        style: {
                          "transform-origin": "30%",
                          "font-size": "14px"
                        }
                      })];
                    }),
                    default: _withCtx(function () {
                      return [_hoisted_17];
                    }),
                    _: 1
                  }, 8, ["onClick"])];
                }),
                _: 1
              }, 512), [[_vShow, !_ctx.questionService.showIde && !_ctx.examService.answerMode]])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_WorkProfileDialog)]);
}